<template>
	<div class="banner">
		<div class="content_box">
			<h1 class="title">GUIDANCE</h1>
			<h1 class="title">FOR USE</h1>
			<p class="year">8年时光</p>
			<p class="dest"><span class="dest_sp"><span>科飞只关注您的眼健康！</span></span></p>
		</div>
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style scoped>
	.banner{ position: relative;height: 400px;background-image: url(../../../../assets/guide_banner.png);background-repeat: no-repeat;background-position: center center; }
	.banner .content_box{ width: 1200px;margin: 0 auto;padding: 88px 630px 0 115px; }
	.banner .title{ font-size: 36px;color: #fff;line-height: 36px; }
	.banner .year{ margin-top: 22px;font-size: 20px;color: #fff;line-height: 28px; }
	.banner .dest{ margin-top: 6px;font-size: 30px;color: #fff;line-height: 30px; }
	.banner .dest .dest_sp{ display: inline-block;position: relative; }
	.banner .dest .dest_sp::before{ content: "";display: block;position: absolute;z-index: 5;width: 100%;height: 11px;bottom: 0;left: 0;background: #ffb805; }
	.banner .dest_sp span{ display: inline-block;position: relative;z-index: 9; }
</style>
